export default __webpack_public_path__ + "static/media/arystofanes.51174fe2.jpg";